<template>
      <div no-body class="lku-charges"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else>
        <b-col cols="10">
          <b-form-group label-cols=1 label="Filter" >
            <b-form-row>
              <b-col cols="6">
                  <b-form-input v-model="tblData.name" placeholder="Name" @keyup.13.native="refresh()"></b-form-input>
              </b-col>
              <b-col cols="6">
                  <b-form-input v-model="tblData.contact" placeholder="Contact Name" @keyup.13.native="refresh()"></b-form-input>
              </b-col>
            </b-form-row>
          </b-form-group>
          </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblCust" style="font-size:smaller;" 
          responsive small striped hover
          :items="data"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit" 
          @row-clicked="selectItem"
        >
        <template v-slot:cell(Address1)="data">
          {{ data.item.Address1 }}
          {{ data.item.Address2 }}
        </template>
        </b-table>
        <b-row>
          <b-col cols="6">
            <div>
              Showing {{(tblData.page - 1) * tblData.limit + 1}}
              to
              <span
                v-if="((tblData.page * tblData.limit)>tblData.total)"
              >{{tblData.total}}</span>
              <span v-else>{{tblData.page * tblData.limit}}</span>
              of {{tblData.total}} entries,
              <span
                class="ml-3 mr-1"
              >limit per page :</span>
              <select v-model="tblData.limit" style="width:60px;">
                <option>10</option>
                <option>15</option>
                <option>20</option>
                <option>25</option>
                <option>30</option>
              </select>
            </div>
          </b-col>
          <b-col cols="6">
            <b-pagination
              align="right"
              :total-rows="tblData.total"
              :per-page="tblData.limit"
              v-model="tblData.page"
            ></b-pagination>
          </b-col>
        </b-row>
  </div>
</template>
<style lang="scss">
  .lku-charges {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import customer from "../../apis/bakerycustomer";

export default {
  data() {
    return {
      fields: [
          { key: "CustCode" , 
            label: "Customer Code",
            sortable: true
          },
          { key: "CustName" , 
            label: "Customer Name",
            sortable: true
          },
          {
            key: "Address1",
            label: "Billing Address",
          },
          {
            key: "City",
            label: "City",
            sortable: true
          },
      ],
      tblData: {
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'CustName',
        sortDesc: false,
        customer_group:''
      },
      lkuLoading:false
    };
  },
  props: {
    customer_group:{
      type: String,
      default: () => ''
    }
  },
  methods: {
    data: async function(ctx) {
      this.tblData.customer_group = 'WHOLESALE';
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading=true;
      const list = await customer.list(this.tblData);      
      this.lkuLoading=false;
      return list;
    },
    selectItem(item,index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    clearFilter() {
        this.tblData={name:'', contact: ''};
        this.refresh();
    },    
    keymonitor: function(event) {
        console.log(event.key);
       if(event.key == "Enter")
       {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblCust.refresh();
       }
    },    
    refresh() {
      this.$refs.tblCust.refresh();
    }
  }
};
</script>
